/**
 * Shows the raw (untranslated) Geotab error text. Use `demystifyError` for translated messages.
 */
export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    const data = (error as Error & { data?: unknown }).data;

    if (typeof data === "string" && data.trim().length > 0) {
      return `${error.message}: ${data.trim()}`;
    }

    if (data instanceof Error) {
      return `${error.message}: ${data.message}`;
    }

    if (data !== null && typeof data === "object") {
      try {
        return `${error.message}: ${JSON.stringify(data)}`;
      } catch {
        return error.message;
      }
    }

    return error.message;
  }

  return String(error);
}
